import { useEffect, useState } from 'react'
import { cloudWatchLogger, validateEmail } from '../../api'
import { Button } from '../../elements/Button'
import { ErrorLabel } from '../../elements/ErrorLabel'
import { AccessCodeInput, ApplicationTypeOptionsRow, ErrorLabelWrapper } from './styles'

type AccessCodeValidatorProps = {
  guid: string | undefined
  applicationTypeId: string | undefined
  onVerify: (value: 'idle' | 'verified' | 'unVerified') => void
  verified: boolean
}

const emailRegex = /^(?!.*\.\.)(?!.*\.\@)[\w._+-]+@[\w.-]+\.[\w]{2,19}$/

export const WhiteListedDomainsValidator = ({
  guid = '',
  applicationTypeId,
  onVerify,
  verified,
}: AccessCodeValidatorProps) => {
  const [email, setEmail] = useState<string | undefined>(undefined)
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)
  const [isValidEmail, setIsValidEmail] = useState(false)

  //reset the verified stats on parent if the component is re-mounted
  useEffect(() => {
    onVerify('idle')
  }, [])

  const verifyEmail = () => {
    setStatus('loading')
    validateEmail({
      guid,
      applicationTypeId,
      email,
    })
      .then(res => {
        if (!res) {
          onVerify('unVerified')
          setErrorMessage('This Email is not valid')
        } else {
          onVerify('verified')
        }
        setStatus('success')
      })
      .catch((error: Error) => {
        setStatus('error')
        setErrorMessage(error.message)
        cloudWatchLogger.error('Email Access Verification', error.message)
      })
  }

  const validEmailAddress = (email: string) => {
    if (!emailRegex.test(email)) {
      setErrorMessage('enter a valid email')
      setIsValidEmail(false)
    } else {
      setIsValidEmail(true)
    }
  }

  const onInputChange = (e: any) => {
    errorMessage && setErrorMessage(undefined)
    status !== 'idle' && setStatus('idle')
    onVerify('idle')
    setEmail(e.target.value)
    validEmailAddress(e.target.value.trim())
  }

  const iconClassName = `fas fa-${errorMessage ? 'times-circle' : 'check-circle'} validation-icon`

  const disableButton = !email?.trim() || status !== 'idle' || !isValidEmail

  const showButton = !verified

  return (
    <ApplicationTypeOptionsRow>
      <span className="name">Your Email Address: </span>
      <AccessCodeInput email={true}>
        {status === 'success' && <i className={iconClassName} />}
        <input
          type="email"
          pattern="^(?!.*\.\.)(?!.*\.\@)[\w._+-]+@[\w.-]+\.[\w]{2,19}$"
          onChange={onInputChange}
        />
        {showButton && (
          <Button
            disabled={disableButton}
            showSpinner={status === 'loading'}
            label="Verify"
            onClick={verifyEmail}
          />
        )}
      </AccessCodeInput>
      {errorMessage && (
        <ErrorLabelWrapper>
          <ErrorLabel>{errorMessage}</ErrorLabel>
        </ErrorLabelWrapper>
      )}
    </ApplicationTypeOptionsRow>
  )
}
